'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _icon = require('@atlaskit/icon');

var _icon2 = _interopRequireDefault(_icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Svg = function Svg(_ref) {
  var title = _ref.title,
      svgProps = _objectWithoutProperties(_ref, ['title']);

  return _react2.default.createElement(
    'svg',
    _extends({ width: '24', height: '24', viewBox: '0 0 24 24', focusable: 'false' }, svgProps, { 'aria-labelledby': 'title-arvrid1' }),
    _react2.default.createElement(
      'title',
      { id: 'title-arvrid1' },
      title
    ),
    _react2.default.createElement(
      'g',
      { fillRule: 'evenodd' },
      _react2.default.createElement('circle', { fill: 'currentColor', cx: '12', cy: '12', r: '6', role: 'presentation' }),
      _react2.default.createElement('circle', { fill: 'inherit', cx: '12', cy: '12', r: '2', role: 'presentation' })
    )
  );
};
var RadioIcon = function RadioIcon(props) {
  return _react2.default.createElement(_icon2.default, _extends({ glyph: Svg }, props));
};
exports.default = RadioIcon;


//////////////////
// WEBPACK FOOTER
// ./~/@atlaskit/droplist/~/@atlaskit/icon/glyph/radio.js
// module id = 336
// module chunks = 0